import fixHyperlinks from "./fixHyperlilnks";

/* eslint-disable no-plusplus */
const makeItemDescInfoObj = (itemDescInfoText) => {
  if (!itemDescInfoText || typeof itemDescInfoText !== 'string') {
    return { description: '', requirements: [] };
  }
  /**
   * There are two lines in itemDescInfoText.  The first line
   * is a truncated version of the first part of the second
   * line, so it can be thrown away.  After the first part of
   * the second line, there are descriptions begining with a
   * key of the form 'Rxnnn' followed by a colon or comma
   * where x is a letter and nnn is a three-digit number.
   */
  const splitLines = itemDescInfoText.trim().split('\n');
  if (!splitLines[1]) {
    return { description: '', requirements: [] };
  }
  const itemDescInfo1 = splitLines[1]
    .replace(/( R.\d{3}[:,-])/g, "\n$1")
    .replace(/(?<= R.\d{3})([[:,-])/g, ':');
  const itemDescInfo2 = itemDescInfo1.split("\n");
  const description = fixHyperlinks(itemDescInfo2[0]);
  const requirements1 = itemDescInfo2.slice(1).sort();
  const requirements = [];
  requirements1.forEach(requirement => {
    const rItems = requirement.trim().split(': ');
    const reqNumber = rItems[0];
    let details = rItems.slice(1).join(': ');
    details = fixHyperlinks(details);

    requirements.push({ reqNumber, details })
  });
  return { description, requirements }
}

export default makeItemDescInfoObj;


// WEBPACK FOOTER //
// ./src/components/grids/ItemDescInfoGrid/makeItemDescInfoObj.jsx